// extracted by mini-css-extract-plugin
export default {"ProductCategoryLabel":"ProductCategoryLabel_ProductCategoryLabel__CuXzA"};